import { InsertLinksHost } from 'owa-attachment-link-common';
import { getAttendeeLists } from 'owa-calendar-compose-form-store/lib/utils/getAttendees';
import type { FullComposeViewState } from 'owa-calendar-compose-types';

export default function getInsertLinksHost(
    composeViewState: FullComposeViewState,
    formId: string
): InsertLinksHost {
    const onGetAttendeeLists = () => {
        return getAttendeeLists(formId);
    };

    return {
        getRecipientWells: onGetAttendeeLists,
        attachmentWell: composeViewState.attachmentWell,
    };
}
